<div class="verify-dialog flex flex-col gap-3">
  <div class="uri self-center flex flex-col items-center">
    <img class="w-[15vw]" [src]="qr" alt="verificationUri">
    <span class="text-gray-400 text-2xl">{{ receivedData.verificationUri }}</span>
  </div>
  <div class="code">
    code: <span class="font-semibold">{{ receivedData.userCode }}</span>
  </div>
  <p-button
    class="self-end"
    styleClass="!text-4xl !py-5 !px-9 !bg-blue-400 !border-blue-500"
    label="Verified!"
    (click)="close()"
  />
</div>
